import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, DatePicker, Select, Modal } from 'components';
import { ExcelIcon, TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ViewIcon, PrintIcon, OperatorsIcon, ConfirmIcon, StarIcon, CanceledIcon, MoneyIcon, CopyIcon } from 'assets/icons';
import { Globals, Constants, Colors, checkPermission, Print } from 'utils';
import { ReportService } from 'services';
import moment from 'moment';
import queryString from 'query-string';
import ModalSurvey from 'screens/admin/quotes/modal-survey';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	service_id: '',
	type_id: ''
}

declare var window: any;

class SurveyReport extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Cliente',
			'Cita Nº',
			'Fecha Solicitud',
			'Fecha Servicio',
			'Servicio',
			'Tipo de Limpieza',
			'Acciones'
		],
		item: null,
		types: [],
		services: [],
		visible_survey: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Datos Encuesta de Satisfacción',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
		this.loadTypes();
	}

	loadTypes = async () => {
		const res: any = await ReportService.admin.getTypes({
			withoutLoading: true
		});
		this.setState({
			services: res.services || [],
			types: res.types || []
		});
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReportService.admin.getSurveys({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		await this.setState({
			data: res.surveys.rows,
			last_page: res.surveys.count
		},() => callback());
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	viewSurvey = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item: item?.quote,
			visible_survey: true
		});
	}

	onCloseSurvey = () => {
		this.setState({
			visible_survey: false,
			item: null
		});	
	}
	
	render() {
		const { visible_survey } = this.state;

		return (
			<div id="admin-reports-surveys">
				<Modal
		          className="modal-survey"
		          visible={ visible_survey }
		          title=""
		          centered
		          onClose={ () => this.onCloseSurvey() }
		        >
		        	<ModalSurvey
		        		onClose={ () => this.onCloseSurvey() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-10">
						<div className="row">
							<div className="row col-md-10">
								<div className="col-md-4">
									<Input
										searchLeft
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar por Cliente o Nº Cita"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-4">
									<Select
										placeholder="Servicio"
										name="service_id"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.service_id }
										options={ this.state.services?.map((item: any) => {
											return {
												value: item.id,
												label: item.name
											}
										}) } />
								</div>
								<div className="col-md-4">
									<Select
										placeholder="Tipo"
										name="type_id"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.type_id }
										options={ this.state.types?.map((item: any) => {
											return {
												value: item.id,
												label: item.name
											}
										}) } />
								</div>
								<div className="col-md-4">
									<DatePicker
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-4">
									<DatePicker
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.quote?.user?.full_name || '-' }</td>
								<td>{ i.quote?.number }</td>
								<td>{ moment(i.quote?.created_at).format('DD/MM/YYYY') }</td>
								<td>{ moment(i.quote?.date).format('DD/MM/YYYY') }</td>
								<td>{ i.quote?.service?.name || '-' }</td>
								<td>{ i.quote?.type?.name || '-' }</td>
								<td>
									<Tooltip title="Ver Encuesta">
										<a className="link-icon" href="#" onClick={ (e: any) => this.viewSurvey(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(SurveyReport);